<template>

    <div>

        <span id="tooltip-target-update-provider">
            <b-button variant="info"
                @click=" updateProvider "
                :disabled=" isDisabled || isLoading "
                class="d-flex align-items-center justify-content-between">

                <i :class=" iconClasses "></i>
                Update Provider in UPD
            </b-button>
        </span>
        <b-tooltip target="tooltip-target-update-provider" triggers="hover">
            {{ tooltipTitle }}
        </b-tooltip>
    </div>
</template>

<script>

    import LoadingToggles from '../../mixins/LoadingToggles';

    export default {

        mixins: [ LoadingToggles ],
        props: {

            providerdata : Object,
            isDisabled   : Boolean
        },
        data(){

            return {

                isLoading : false
            }
        },
        computed: {

            tooltipTitle(){

                return ( this.isDisabled ? 'A matched provider must be selected first.' : 'Update this UPD record with the data currently in CareExchange.' );
            }
        },
        methods: {

            updateProvider(){

                let form = new Form( this.providerdata );
                this.isLoading = true;
                form.post( `/business/upd_api/updateProviderFor/${this.providerdata.id}` )
                    .then( res => { /* will reload page */ })
                    .finally( () => this.isLoading = false );
            }
        },
        mounted(){

        }
    }
</script>

<style>

</style>